import { createSlice } from '@reduxjs/toolkit';

const UserNotificationSlice = createSlice({
  name: 'GetUserNotificationsService',
  initialState: {
    loading: false,
    data: null,
    error: null,
    success: false
  },
  reducers: {
    GetUserNotificationsServiceInit(state) {
      state.loading = true;
      state.error = null;
    },
    GetUserNotificationsServiceSuccess(state, action) {
      state.loading = false;
      state.data = action.payload;
      state.success = true;
    },
    GetUserNotificationsServiceFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
      state.success = false;
    },
    GetUserNotificationsServiceReset(state) {
      return { ...state, loading: false, data: null, success: false, error: null };
    },
  },
});

export const {
  GetUserNotificationsServiceInit,
  GetUserNotificationsServiceSuccess,
  GetUserNotificationsServiceFailure,
  GetUserNotificationsServiceReset
} = UserNotificationSlice.actions;

export default UserNotificationSlice.reducer;
